export default ({ request }) => ({
  ecomEvgSpuListApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/list',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuDetailApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/detail',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuSaveApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/save',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuDelApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/del',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuFullMemberApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/fullMember',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuApplyApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/apply',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuApprovedApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/approved',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuRejectApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/reject',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuBindSpuBySpuCodeApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/bindSpuBySpuCode',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuAddSkuApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/add/sku',
      method: 'post',
      data,
    })
  },
  ecomEvgSpuChangeNameApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/changeName',
      method: 'post',
      data,
    })
  },

  // SPU 产品图片
  ecomEvgSpuImageListApi(data = {}) {
    return request({
      url: '/ecom/evg/spu/image/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSpuImageUploadApi(data = {}) {
    return request({
      url: '/ecom/evg/spu/image/upload',
      method: 'POST',
      data,
    })
  },
  ecomEvgSpuImageSetDefaultApi(data = {}) {
    return request({
      url: '/ecom/evg/spu/image/setDefault',
      method: 'POST',
      data,
    })
  },
  ecomEvgSpuImageDelApi(data = {}) {
    return request({
      url: '/ecom/evg/spu/image/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgSpuNewCollectionApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/new/collection',
      method: 'POST',
      data,
    })
  },
  ecomEvgSpuRemoveSkuApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/removeSku',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuListBySpuCodeApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/listBySpuCode',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuChangeDesignApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/changeDesign',
      method: 'POST',
      data,
    })
  },

  // 客户相关
  ecomEvgSpuCustBrandSelectApi(data = {}) {
    return request({
      url: '/ecom/ecom/evg/spu/custBrand/select',
      method: 'post',
      data,
    })
  },
})
